import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import MemberShipStore from './member/MemberShipStore';
import LoginStore from './member/LoginStore';
import UserInfoChangeStore from './member/UserInfoChangeStore'
import OrderStore from './order/OrderStore';
import GiftShopStore from './giftshop/GiftShopStore';
import ShopStore from './shop/ShopStore';
import PaymentStore from './payment/PaymentStore';

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        MemberShipStore: MemberShipStore,
        LoginStore: LoginStore,
        OrderStore: OrderStore,
        GiftShopStore: GiftShopStore,
        ShopStore: ShopStore,
        PaymentStore:PaymentStore,
        UserInfoChangeStore,
    }
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js